import { isPreview, isPrivacyPage } from "@otto-ec/global-resources/misc";
import { toggle } from "@otto-ec/global-resources/toggle";
import { exactagScope } from "../core/utils.js";
import { getConsentForGV } from "@otto-ec/eprivacy-cmp";

const log = exactagScope.scope("consent.otto");

export interface Consent {
  /**
 *
 */
  received: boolean;
  /**
 *
 */
  accept: boolean;
}

/**
 *
 */
export const PXC_ENABLED_TOGGLE = "ofc_om_exactag_enable";

/**
 *
 */
export const eprivacyConsent = "eprivacy.cmp.consentChanged";

/**
 *
 *
 *
 */
export const consents: Record<string, Consent> = {
  [eprivacyConsent]: { received: false, accept: false },
};

/**
 *
 */
export const consentResult: Consent = { received: false, accept: false };

/**
 *
 *
 *
 *
 */
export function getConsents(): typeof consents {
  return Object.fromEntries(Object.entries(consents).map(([key, value]) => [key, { ...value }]));
}

/**
 *
 *
 *
 *
 */
export function getConsentResult(): typeof consentResult {
  return { ...consentResult };
}

/**
 *
 *
 *
 *
 */
export function userConsentsAccepted(): boolean {
  /*                                                          */
  return !!(consentResult.received && consentResult.accept);
}

/**
 *
 *
 *
 *
 *
 */
export function updateConsent(consent: string, yes: boolean | null): boolean {
  consents[consent].received = true;
  consents[consent].accept = !!yes;

  /*                                                               */
  /*                                 */
  /*                                                                     */
  consentResult.accept = true;
  consentResult.received = true;

  /*                                                                 */
  Object.keys(consents).forEach((k) => {
    consentResult.received = consentResult.received && consents[k].received;
    consentResult.accept = consentResult.accept && consents[k].accept;
  });

  log.info("Consent result: received", consentResult.received, "accept", consentResult.accept);
  return userConsentsAccepted();
}

/**
 *
 *
 *
 *
 *
 *
 *
 *
 *
 */
export async function getUserConsentForGV(): Promise<boolean> {
  try {
    return (
      /*                                             */
      toggle.get(PXC_ENABLED_TOGGLE, true) &&
      /*                      */
      !isPreview(window.location.href) &&
      /*                      */
      !isPrivacyPage() &&
      /*              */
      !!(await getConsentForGV("OTTOT"))
    );
  } catch {
    return false;
  }
}
